<template>
  <!-- BUY MODAL -->
  <b-modal
    class="signin-modal"
    :active.sync="showSignInModal"
    style="padding: 0 16px;"
    has-modal-card
    :can-cancel="false"
  >
    <div class="modal-card">
      <div class="modal-card-head p-0">
        <nav class="has-border-bottom">
          <!-- back -->
          <div class="container">
            <div class="navbar-brand">
              <div
                class="navbar-item"
                @click="$store.dispatch('ui/toggleModal', { name: 'SIGNIN_MODAL', state: false })"
              >
                <span class="icon">
                  <i class="mdi mdi-close mdi-24px"></i>
                </span>
              </div>
            </div>
          </div>
        </nav>
      </div>

      <div class="modal-card-body">
        <div class>
          <p class="title is-4">{{ $t('ui.toContinue') }}</p>

          <!-- signIn -->
          <div class="">
            <div class="buttons" v-show="!showLoginWithEmail">
              <b-button
                class="button is-outlined is-default-size is-fullwidth"
                icon-left="google"
                @click="$store.dispatch('auth/googleSignIn')"
              >{{ $t('auth.signInWithGoogle') }}</b-button>

              <b-button
                class="button is-outlined is-default-size is-fullwidth"
                disabled
                icon-left="facebook"
              >{{ $t('auth.signInWithFacebook') }}</b-button>

                <!-- @click="showLoginWithEmail = true" -->
              <b-button
                class="button is-outlined is-default-size is-fullwidth"
                icon-left="email-outline"
                @click="$router.push({name: 'signin'})"
              >{{ $t('auth.loginWithMail') }}</b-button>
            </div>

            <div v-show="showLoginWithEmail" class="mt-1">
              <p class="is-size-6-half has-text-centered has-text-weight-semibold">
                <!-- <a class="has-text-link" href>Facebook</a>&nbsp;yada -->
                <a
                  href
                  class="has-text-cyan"
                  @click.prevent="$store.dispatch('auth/googleSignIn')"
                >Google</a>&nbsp;ile hesap aç
              </p>
              <hr class="hr-text" :data-content="$t('ui.or')" />
            </div>

            <div v-show="showLoginWithEmail">
              <!-- GIRIS YAP -->
              <b-field class="is-fullwidth">
                <b-input size="is-medium" :placeholder="$t('auth.email')" type="email" icon="email"></b-input>
              </b-field>

              <b-field>
                <b-input size="is-medium" :placeholder="$t('auth.password')" icon="lock"></b-input>
              </b-field>

              <b-button
                class="button is-default-size is-primary is-fullwidth"
              >{{ $t('auth.logIn') }}</b-button>

              <p class="has-text-centered mt-1 is-size-6">
                {{ $t( 'auth.dontHaveAccount', { msg: $store.state.appName }) }}
                <router-link :to="{ name: 'signup' }">{{ $t('auth.signUp') }}</router-link>
              </p>
            </div>

            <div v-if="$route.name && $route.name.includes('event-view')">
              <div class="container">
                <hr class="hr-text" :data-content="$t('ui.or')" />
              </div>

              <b-field class="mt-2">
                <b-button
                  class="button is-outlined is-fullwidth is-default-size"
                  @click="continueWithoutSignUp"
                >{{ $t('auth.continueWithoutSignUp') }}</b-button>
              </b-field>
            </div>
          </div>

          <!-- <p class="title is-4 mt-2">Üye olmadan devam et</p> -->
        </div>
      </div>
    </div>
  </b-modal>
  <!-- ./BUY MODAL -->
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      showLoginWithEmail: false
    };
  },
  watch: {
    $route() {
      this.$store.dispatch('ui/closeAllModals')
    }
  },
  computed: {
    ...mapGetters({
      showSignInModal: "ui/showSignInModal"
    })
  },
  created() {
    if (process.env.NODE_ENV === "development") {
      console.log("SignInModal.vue is created");
    }
  },
  methods: {
    continueWithoutSignUp() {
      this.$store.dispatch("ui/toggleModal", {
        name: "SIGNIN_MODAL",
        state: false
      });
      this.$store.commit("ui/SET_ROUTE_LOCK", false);
      this.$router.push({ name: "payment-event-rules" });
      // console.log('por que no?');
    }
  }
};
</script>
